export default "__VITE_ASSET__076eb392__"